type LogoProps = {
  color?: "white" | "black";
  className?: string;
};

export default function Logo({ color = "black", className = "" }: LogoProps) {
  return (
    <div className={`flex items-center ${className}`}>
      <img
         src={`${color === "black" ? "/assets/images/logo-talentlink-scroll.png" : "/assets/images/logo-talentlink.png"}
        `}
        alt="TalentLink Logo"
        className={`
          h-20 w-auto relative right-2 md:right-3 transition-all duration-300
          ${color === "black" ? "" : ""}
        `}
      />
    </div>
  );
}
